export function throwIf(value: boolean, message: string) {
  if (value) throw new Error(message)
}
